var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubstrateActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65973 1.33398H1.83325V3.11617L3.65973 1.33398Z",
    fill: "#009FDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 4.47129L5.04853 1.33398H7.25123L1.83325 6.62057V4.47129Z",
    fill: "#009FDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 7.97569V10.125L10.8427 1.33398H8.64003L1.83325 7.97569Z",
    fill: "#009FDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2315 1.33398L1.83325 11.4801V13.6294L14.4342 1.33398H12.2315Z",
    fill: "#009FDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 1.97451L2.1583 14.6673H4.361L15.1666 4.12379V1.97451Z",
    fill: "#009FDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 5.47891L5.7498 14.6673H7.9525L15.1666 7.62819V5.47891Z",
    fill: "#009FDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 8.98331L9.3413 14.6673H11.544L15.1666 11.1326V8.98331Z",
    fill: "#009FDF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 12.4877L12.9328 14.6673H15.1355L15.1666 14.637V12.4877Z",
    fill: "#009FDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstrateActive);
export default __webpack_public_path__ + "static/media/substrate-active.cb4d49fc13ede6d3f3e0394386e2cb17.svg";
export { ForwardRef as ReactComponent };